import React from 'react';

const FormGrid = ({ 
  children, 
  columns = 2,
  gap = 4,
  className = '',
  ...props 
}) => {
  const gridClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  };

  const gapClasses = {
    2: 'gap-2',
    3: 'gap-3',
    4: 'gap-4',
    6: 'gap-6',
    8: 'gap-8'
  };

  const gridClass = gridClasses[columns] || gridClasses[2];
  const gapClass = gapClasses[gap] || gapClasses[4];

  return (
    <div className={`grid ${gridClass} ${gapClass} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default FormGrid;
